const topMain = () => {
  if (document.querySelector("body#pageTop") !== null) {



    let secMain = document.querySelector('#jsSecMain');
    let mainTopWrap = secMain.querySelector('.js-main-top-wrap');
    let logo = mainTopWrap.querySelector('.js-logo');
    let lead = mainTopWrap.querySelector('.js-lead');


    setTimeout(() => {
      logo.classList.add('act')
      setTimeout(() => {
        lead.classList.add('act')
      }, 600);
    }, 600);



  }
}
export default topMain;